import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface BookIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const BookIcon = ({ className, ...props }: BookIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.5 5H16C16.8284 5 17.5 5.67157 17.5 6.5V8"
      stroke="#3F3A3B"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M19.3284 20.8284L18.7981 20.2981L18.7981 20.2981L19.3284 20.8284ZM18.5 2.75C18.9142 2.75 19.25 2.41421 19.25 2C19.25 1.58579 18.9142 1.25 18.5 1.25V2V2.75ZM20.5 10H19.75V14H20.5H21.25V10H20.5ZM12.5 22V21.25H11.5V22V22.75H12.5V22ZM3.5 14H4.25V5H3.5H2.75V14H3.5ZM11.5 22V21.25C9.59318 21.25 8.23851 21.2484 7.21085 21.1102C6.20476 20.975 5.62511 20.7213 5.2019 20.2981L4.67157 20.8284L4.14124 21.3588C4.88961 22.1071 5.83855 22.4392 7.01098 22.5969C8.16182 22.7516 9.63558 22.75 11.5 22.75V22ZM3.5 14H2.75C2.75 15.8644 2.74841 17.3382 2.90313 18.489C3.06076 19.6614 3.39288 20.6104 4.14124 21.3588L4.67157 20.8284L5.2019 20.2981C4.77869 19.8749 4.52502 19.2952 4.38976 18.2892C4.25159 17.2615 4.25 15.9068 4.25 14H3.5ZM20.5 14H19.75C19.75 15.9068 19.7484 17.2615 19.6102 18.2892C19.475 19.2952 19.2213 19.8749 18.7981 20.2981L19.3284 20.8284L19.8588 21.3588C20.6071 20.6104 20.9392 19.6614 21.0969 18.489C21.2516 17.3382 21.25 15.8644 21.25 14H20.5ZM12.5 22V22.75C14.3644 22.75 15.8382 22.7516 16.989 22.5969C18.1614 22.4392 19.1104 22.1071 19.8588 21.3588L19.3284 20.8284L18.7981 20.2981C18.3749 20.7213 17.7952 20.975 16.7892 21.1102C15.7615 21.2484 14.4068 21.25 12.5 21.25V22ZM18.5 2V1.25H6.5V2V2.75H18.5V2ZM6.5 8V8.75H18.5V8V7.25H6.5V8ZM3.5 5H2.75C2.75 7.07107 4.42893 8.75 6.5 8.75V8V7.25C5.25736 7.25 4.25 6.24264 4.25 5H3.5ZM6.5 2V1.25C4.42893 1.25 2.75 2.92893 2.75 5H3.5H4.25C4.25 3.75736 5.25736 2.75 6.5 2.75V2ZM20.5 10H21.25C21.25 8.48122 20.0188 7.25 18.5 7.25V8V8.75C19.1904 8.75 19.75 9.30964 19.75 10H20.5Z"
      fill="#3F3A3B"
    />
    <path
      d="M12 11L13.4254 13.5746L16 15L13.4254 16.4254L12 19L10.5746 16.4254L8 15L10.5746 13.5746L12 11Z"
      stroke="#161515"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

export default BookIcon;
